export const truncateHtml = (
  html: string,
  maxLines: number
): { truncatedHtml: string; showMoreBtn: boolean } => {
  const totalLines = html.split("\n").length;
  const truncatedHtml = html.split("\n").slice(0, maxLines).join("");
  const showMoreBtn = totalLines > maxLines;
  return { truncatedHtml, showMoreBtn };
};
